import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
    COMMISSIONS_GET_POLICY_BY_ID_SUCCESS,
    COMMISSIONS_GET_POLICY_BY_ID_FAILURE
} from '../constants'

export function* getPolicyByIdSaga({ data: { id }}) {
  try {
      const result =  yield call(BFFAgent.Commission.getPolicyById,id)
      yield put({
          type: COMMISSIONS_GET_POLICY_BY_ID_SUCCESS,
          data: result.data
      })
  } catch (error) {
    yield put({
      type: COMMISSIONS_GET_POLICY_BY_ID_FAILURE,
      data: { error }
    })
  }
}